import { uniq } from 'lodash'
import { Page } from '../../../models/util.model'
import { InvoiceListingKeys } from '../models/invoice-listing.model'
import { Invoice } from '../models/invoice.entity'

/**
 * Parse invoice page keys
 * @param page - the invoices page
 * @returns the page listing keys
 */
export function parseInvoicePageKeys(page: Page<Invoice>): InvoiceListingKeys {
  return page.data.reduce<InvoiceListingKeys>(
    (acc, r) => parseInvoiceKeys(r, acc),
    {},
  )
}

/**
 * Parse invoice keys
 * @param invoice - the invoice
 * @param keys - the keys already loaded
 * @returns the invoice listing keys
 */
export function parseInvoiceKeys(
  invoice: Invoice,
  keys: InvoiceListingKeys = {},
): InvoiceListingKeys {
  const carrierIds = uniq([
    ...(keys['carrierIds'] || []),
    ...(invoice.carrierId ? [invoice.carrierId] : []),
  ])
  const channelIds = uniq([
    ...(keys['channelIds'] || []),
    ...(invoice.header.channel ? [invoice.header.channel] : []),
  ])

  return {
    carrierIds,
    channelIds,
  }
}
